export default __webpack_public_path__ + "static/media/Sweet B's Long.11ca544c.png";